import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const timeSeriesMetric = z.array(
  z.object({ plainDate: z.string(), value: z.number().optional() }),
);

export const getWidgetsTimeSeriesMetrics = {
  name: "getWidgetsTimeSeriesMetrics" as const,
  input: z.null(),
  output: z.object({
    incrementalRevenueOverTimeSeries: timeSeriesMetric,
    currency: createEnum(Currency),
  }),
};
